module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.classNames
  }, [(_vm.section.has_media) ? [_c('div', {
    staticClass: "media",
    class: _vm.section.media.type
  }, [(_vm.section.media.type == 'embed') ? [_c('vue-embedplayer', {
    attrs: {
      "media": _vm.section.media,
      "current": _vm.mediaPlaying
    }
  })] : _vm._e(), _vm._v(" "), (_vm.section.media.type == 'video') ? [_c('vue-videoplayer', {
    attrs: {
      "media": _vm.section.media,
      "current": _vm.mediaPlaying
    }
  })] : _vm._e(), _vm._v(" "), (_vm.section.media.type == 'audio') ? [_c('vue-audioplayer', {
    attrs: {
      "media": _vm.section.media,
      "current": _vm.mediaPlaying
    }
  })] : _vm._e()], 2)] : _vm._e(), _vm._v(" "), (_vm.section.hasImages) ? [_c('div', {
    staticClass: "pictures",
    class: _vm.section.imageClasses
  }, [_vm._l((_vm.section.images), function(img, imgIndex) {
    return [_c('figure', {
      key: imgIndex,
      class: 'fig-' + imgIndex
    }, [_c('vue-flexpic', {
      attrs: {
        "imgset": img,
        "sizes": _vm.sizes,
        "aspect": img.aspect,
        "className": img.attributes.className
      }
    }), _vm._v(" "), (img.attributes.title) ? _c('figcaption', [_vm._v(_vm._s(img.attributes.title))]) : _vm._e()], 1)]
  })], 2)] : _vm._e(), _vm._v(" "), (_vm.section.type == 'quote') ? [(_vm.section.text) ? _c('blockquote', {
    staticClass: "text",
    domProps: {
      "innerHTML": _vm._s(_vm.section.text)
    }
  }) : _vm._e(), _vm._v(" "), _c('h4', {
    staticClass: "author"
  }, [_vm._v(_vm._s(_vm.section.title))])] : [(_vm.section.title) ? _c('h4', {
    staticClass: "subtitle"
  }, [_vm._v(_vm._s(_vm.section.title))]) : _vm._e(), _vm._v(" "), (_vm.section.text) ? _c('div', {
    staticClass: "text",
    domProps: {
      "innerHTML": _vm._s(_vm.section.text)
    }
  }) : _vm._e()]], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1d1f5a8c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Paragraph.vue
// module id = 42
// module chunks = 0